import { useMemo } from 'react'
import { panelPublicUrl } from '../../../../../../panelurl'
import { PresimPaneltype } from '../../../utils/scenario-types'
import ThermalUpload from './ThermalUpload'

const GraphFrame = ({ title, modalId, graphs }: { title: string, modalId: string, graphs: PresimPaneltype[] }) => {

    const showThermalUploadButton = useMemo(() => modalId === 'thermal', [modalId])

    return (
        <div className='presim__report__container__body'>
            {!(showThermalUploadButton && !graphs?.length) && (
                <div className='presim__report__container__body__header'>
                    <div className='presim__report__container__body__header__text'>{title}</div>
                </div>
            )}
            <div className='presim__graphs__container'>
                {showThermalUploadButton && <ThermalUpload graphs={graphs} modalId={modalId} />}
                {graphs?.map((item, index) => (
                    <div className='graph__container' key={`graph-${modalId}-${index}`}
                        data-index={index}
                    >
                        <iframe sandbox="allow-scripts allow-same-origin" margin-height='0' src={`${panelPublicUrl}${item?.['url']}`} loading="lazy" />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default GraphFrame